import React from "react";
import { PageContentSkeleton } from "../ListCardSkeleton";

export default function PageLoader() {
  return <PageContentSkeleton />;
}
